"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Inbox/InboxList/Header/TeamPicker/Title.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _reactredux = require('react-redux');


var _team = require('shared/selectors/team');
var _hooks = require('web/services/hooks');

var _icons = require('../../icons');
var _org = require('shared/selectors/org');





const Title = ({ teamKey }) => {
  const selected = _hooks.useAppSelector.call(void 0, state => {
    const team = teamKey && _team.selectTeamByKey.call(void 0, state, teamKey)
    const orgKey = _optionalChain([team, 'optionalAccess', _ => _.OrgKey])
    const org = orgKey && _org.selectOrgByKey.call(void 0, orgKey, state)

    if (!teamKey || !team || !org) return null

    return { teamName: team.Name, orgName: org.Name }
  }, _reactredux.shallowEqual)

  const hasTeamSelected = !!selected
  const teamName = _optionalChain([selected, 'optionalAccess', _2 => _2.teamName])
  const orgName = _optionalChain([selected, 'optionalAccess', _3 => _3.orgName])

  return (
    _react2.default.createElement('div', { className: "inbox-list-header--title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 31}}
      , _react2.default.createElement('div', { className: "inbox-list-header--name", __self: this, __source: {fileName: _jsxFileName, lineNumber: 32}}
        , _react2.default.createElement('span', { className: "inbox-list-header--name-text", __self: this, __source: {fileName: _jsxFileName, lineNumber: 33}},  teamName || 'My Inbox' )
        , _react2.default.createElement(_icons.ChevronDownIcon, { className: "inbox-list-header--chevron", __self: this, __source: {fileName: _jsxFileName, lineNumber: 34}} )
      )
      ,  hasTeamSelected && (
        _react2.default.createElement('div', { className: "inbox-list-header--subtitle", __self: this, __source: {fileName: _jsxFileName, lineNumber: 37}},  orgName , " · team inbox"   )
      )
    )
  )
}

exports. default = _react.memo.call(void 0, Title)
